import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { setKam } from '@/data/api/request/buyersRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useSetKam() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  return useMutation({
    mutationFn: setKam,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.buyer.details, variables.buyerId],
      });
      showSnackSuccess('KAM/Hunter Assignada');
    },
    onError: () => showSnackError('Error asignar KAM/Hunter'),
  });
}
